export const CATEGORIES = {
    FOR_SALE: {
        id: 2549,
        name: 'For Sale',
    },
    PET: {
        id: 2526,
        name: 'Pets',
    },
    PROPERTY: {
        id: 10201,
        name: 'Property',
    },
    MOTORS: {
        id: 2551,
        name: 'Motors',
    }
}
